import api from "./../api";
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    items: [],
    total: 0,
    page: 1,
    pageSize: 20,
  },
  getters: {
    getCorporatePercentages(state) {
      return state.items;
    },
    getCorporatePercentagesTotal(state) {
      return state.total;
    },
    getCorporatePercentagesPage(state) {
      return state.page;
    },
    getCorporatePercentagesPageSize(state) {
      return state.pageSize;
    },
  },
  mutations: {
    setCorporatePercentages(state, payload) {
      state.items = payload.items || [];
      state.total = payload.total || 0;
      state.page = payload.page || 1;
      state.pageSize = payload.pageSize || state.pageSize;
    },
  },
  actions: {
    fetchAll({ commit, state }, data) {
      return new Promise((resolve, rej) => {
        const body = {
          page: data?.page || state.page,
          pageSize: data?.pageSize || state.pageSize,
          searchText: data?.searchText || null,
        };
        api()
          .post(`corporatePercentages/listAll`, body, {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            commit("setCorporatePercentages", {
              items: res.data.items || [],
              total: res.data.total || 0,
              page: res.data.page || body.page,
              pageSize: res.data.pageSize || body.pageSize,
            });
            resolve(res);
          })
          .catch((err) => {
            console.log(err);
            rej(err);
          });
      });
    },
    fetchByCorporate({ commit, state }, data) {
      return new Promise((resolve, rej) => {
        const body = {
          corporateId: data.corporateId,
          page: data.page || state.page,
          pageSize: data.pageSize || state.pageSize,
        };
        api()
          .post(`corporatePercentages/listByCorporate`, body, {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            console.log(err);
            rej(err);
          });
      });
    },
    add({ dispatch }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(`corporatePercentages/add`, data, {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            console.log(err);
            rej(err);
          });
      });
    },
  },
};



